import { loadable } from '../../components/Loadable/index';

export const LoadableCoursesPage = loadable(() => import('./connector'), {
  resolveComponent: (mod) => mod.ConnectedCoursesPage,
});
